module.exports = "./img/8fca1693009a180666f432056f86b449.jpg";